<zui-toast-notification header-text="To make the most of the AI toolkit, please keep the following points in mind:" state="default" class="w-100" theme="dark">
    <div class="mt-2">
        <ul class="notification-list mb-0">
            <li>{{ 'MACHINE_LEARNING.GREAT_ML_EXPERIENCE.POINT1' | translate }}</li>
            <li>{{ 'MACHINE_LEARNING.GREAT_ML_EXPERIENCE.POINT2' | translate }}</li>
            <li>{{ 'MACHINE_LEARNING.GREAT_ML_EXPERIENCE.POINT3' | translate }}</li>
            <li>{{ 'MACHINE_LEARNING.GREAT_ML_EXPERIENCE.POINT4' | translate }}</li>
            <li>{{ 'MACHINE_LEARNING.GREAT_ML_EXPERIENCE.POINT5' | translate }}</li>
        </ul>
    </div>
    <zui-icon-ewi-ewi-colored-dark-info slot="icon"></zui-icon-ewi-ewi-colored-dark-info>
</zui-toast-notification>
